import { DetectionVehicleTypes } from '../enums/vehicleType';

// FIXME: We have too many similar colors, we should reduce them

export const basic = {
  haydenAccent: '#2730F5',
  haydenPlaceholder: '#696a75',
  haydenBlueGray: '#C2C2D5',
  haydenHover: '#F3F5F9',
  haydenBackground: '#FBFCFE',
  haydenGreyBackground: '#f6f7f8',
  haydenBorder: '#E4E9FB',
  haydenBorderSecond: '#f5f5f5',
  haydenWhite: '#FFFFFF',
  haydenBrand: '#4a90e2',
  haydenDarkBrand: '#3f618c',
  haydenGhostHover: '#0810af',
  haydenGhostFocus: '#060b7f',
  haydenGhostDisabled: '#adafea',
  haydenLogin: '#007bff',
  haydenOrange: '#ff9d0a',
  haydenYellow: '#ebb15b',
  haydenLogo: '#0039a6',
  haydenGreen: '#1aa053',
  haydenRed: '#eb4c55',
  haydenNeutral: '#44546f',
  haydenAnthracite: '#212529',
  haydenLight: '#F0F0F1',
  haydenLightSteel: '#dae0e5',
  haydenDarkSand: '#989898',
  haydenLight2: '#f2f2f2',
  haydenDarkSand2: '#495057',
  haydenLightSteel2: '#ced4da',
  haydenLightSteel3: '#edf1fc',
  haydenLightSteel4: '#f6f8fe',
  haydenGray: '#6c757d',
  haydenGray2: '#ccc',
  haydenAnthracite2: '#343a40',
  haydenAlmostBlack: '#1d2124',
  haydenAnthracite3: '#23272B',
  haydenDisabled: '#888b8e',
  haydenInfo: '#3498db',
  hoverBackgroundRGBA: 'rgba(128, 128, 128, 0.1)',
  haydenAccentLight: '#e5f3ff',
  haydenGreenLight: '#e7f5ef',
  haydenOrangeLight: '#fff4e5',
  haydenRedLight: '#ffeded',
  haydenChevron: '#717680',
  jiraBlockedPurple: '#C200CC',
  jiraMonitoringBlue: '#3167ff',
};

export const grey = {
  haydenGreyShade1: '#1A1A1A',
  haydenGreyShade2: '#4D4D4D',
  haydenGreyShade3: '#808080',
  haydenGreyShade4: '#B3B2B2',
  haydenGreyShade5: '#E5E5E5',
};

export const diagramColors = {
  orange: '#ff7c43',
  red: '#eb4c55',
  blue: '#3bb3f6',
  yellow: '#ebb15b',
  pinkAsFuchsia: '#ff0d90',
  brownSugar: '#CA6C0F',
  kingCrismon: '#C5084F',
  lightPurple: '#B6A6E9',
};

// Asset management tag icon colors
// These colors are used in SVG icons for asset detection tags
export const TagColors = {
  // Primary colors - main icon elements
  primary: '#6995F9', // Blue for main icon shapes
  primaryDark: '#5B8DEE', // Darker blue for strokes/borders
  primaryLight: '#82A7F0', // Lighter blue for secondary elements
  primaryFaded: '#ADC4FB', // Faded blue for decorative elements

  // Background colors
  backgroundLight: '#DAE4FC', // Light blue background (most icons)
  backgroundGreen: '#D1FADF', // Light green background (good condition)

  // Accent colors
  accentGreen: '#039855', // Green for good condition icon
  accentRed: '#EB4C55', // Red (unused currently, but available)
  accentOrange: '#FF9D0A', // Orange (unused currently, but available)
};

export const warningColors = {
  accent: '#F54900',
  background: '#FFFAEB',
  text: '#7E2A0C',
};

export const detectionColors = {
  violation: {
    [DetectionVehicleTypes.BUS]: '#FF0D90',
    [DetectionVehicleTypes.CAR]: '#FF2101',
    [DetectionVehicleTypes.TRUCK]: '#FF740D',
    generic: '#fd5d46',
  },
  detection: {
    [DetectionVehicleTypes.BUS]: '#03F3FF',
    [DetectionVehicleTypes.CAR]: '#00ff03',
    [DetectionVehicleTypes.TRUCK]: '#9dff0a',
    generic: '#407641',
  },
};
